const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="border-t">
      <div className="w-full flex flex-col items-center justify-center gap-4 h-24 px-4 md:px-6 lg:px-8 text-center sm:flex-row sm:justify-center">
        <p className="text-sm text-muted-foreground">
          &copy; {currentYear} Snohomish Radio Aero Club. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
